export default __webpack_public_path__ + "static/media/landing-page-customer-login.34cb16de.svg";